import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    otpRequired: {
        id: 'errors.auth.otp_required',
        defaultMessage: 'Otp required',
    },
    incorrectLoginOrPassword: {
        id: 'errors.auth.incorrect_login_or_password',
        defaultMessage: 'Incorrect login or password. Please try again.',
    },
    otpInvalid: {
        id: 'errors.auth.incorrect_email_code',
        defaultMessage: 'The code is incorrect! Please try again.',
    },
    incorrectReferrer: {
        id: 'errors.auth.incorrect_referrer',
        defaultMessage: "We didn't find this referral code!",
    },
    incorrectInviteCode: {
        id: 'errors.auth.incorrect_invite_code',
        defaultMessage: "We didn't find this invite code!",
    },
    badPassword: {
        id: 'errors.auth.bad_password',
        defaultMessage: 'Incorrect password',
    },
    totpInvalid: {
        id: 'errors.auth.incorrect_totp',
        defaultMessage: 'Wrong code. Check your auth app or a backup code',
    },
    invalidPhone: {
        id: 'errors.auth.incorrect_phone',
        defaultMessage: 'Invalid mobile number format',
    },
    invalidInviteCode: {
        id: 'errors.auth.invite-code-error',
        defaultMessage: 'The code is incorrect! Please check the code or ask the person who invited you for a new one.',
    },
    invalidTwoFaCode: {
        id: 'errors.auth.incorrect_two_fa_error',
        defaultMessage: 'Invalid 2fa credentials',
    },
})
